import "../../styles/index.css";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ProgressBar = ({
  step,
  participated,
  connected,
  onCancel, // New prop for reset callback
}) => {
  const getProgressPercentage = () => {
    if (step === 1) return 0;
    if (step === 2) return 20;
    if (step === 3) return 40;
    if (step === 4) return 60;
    if (step === 5 || step === 6) return 100;
    return 100;
  };

  const progressPercentage = getProgressPercentage();

  const handleCancel = () => {
    if (onCancel) {
      onCancel(); // Call parent's reset function
    }
  };

  return (
    <Box className="progress-line-signup">
      <Box
        className="progress-line-left-signup"
        sx={{
          width: `${progressPercentage}%`,
          backgroundColor: "#ED1C2E",
          transition: "width 0.3s ease-in-out",
        }}
      />
      <Box className="progress-line-right-signup" />
      <Box className="cancel-icon-signup">
        <IconButton
          onClick={handleCancel}
          sx={{
            width: 28,
            height: 28,
            minWidth: 28,
            "& .MuiSvgIcon-root": { fontSize: 16 },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ProgressBar;
